import {
	type ComponentProps,
	type PageData,
	Regions,
} from '@enonic/react-components';

export const Page = ({
	data,
	common,
	meta,
	component,
}: ComponentProps<PageData>) => {
	return <Regions common={common} meta={meta} component={component} />;
};
